module.exports = __webpack_public_path__ + "img/icon-conversation-bubble.b2cbe0c1.jpg";